const paths = {
    home: '/',
    project: '/projects/:id',
    job: '/experience/:id',
    education: '/e/:id',
    projects: '/projects',
    jobs: '/experience',
    eduations: '/e'
};

export default paths;